import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import axios from 'axios'
import querystring from 'querystring'

import {Link} from 'react-router-dom';

import Lightbox from 'react-image-lightbox';

import $ from 'jquery'

import {
    setOptionalAttributes,
    setProduct
} from '../../modules/order'

import {
    addProduct
} from '../../modules/cart'

import StaticCheckboxFormType from './../../components/StaticCheckboxFormType';
import StaticInputFormType from './../../components/StaticInputFormType';
import StaticRadioFormType from './../../components/StaticRadioFormType';
import cableTypes from "../../modules/cableTypes";

class OptionalAttributes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            general_attributes: this.getGeneralAttributes(this.props.order.product.packaging_number),
            breakout_connectors: this.getBreakoutConnectors(),
            connector_color_codings: [
                { name: "0 black", input_name: "connector_color_coding", value: "0"},
                { name: "1 brown", input_name: "connector_color_coding", value: "1" },
                { name: "2 red", input_name: "connector_color_coding", value: "2" },
                { name: "3 orange", input_name: "connector_color_coding", value: "3" },
                { name: "4 yellow", input_name: "connector_color_coding", value: "4" },
                { name: "5 green", input_name: "connector_color_coding", value: "5" },
                { name: "6 blue", input_name: "connector_color_coding", value: "6" },
                { name: "7 violet", input_name: "connector_color_coding", value: "7" },
                { name: "8 grey", input_name: "connector_color_coding", value: "8" },
                { name: "9 white", input_name: "connector_color_coding", value: "9" },
            ],
            photoIndex: 0,
            lightboxIsOpen: false
        };
    }

    getGeneralAttributes(packaging_number) {

        let general_attributes = [];

        let exclude_attribute_ids = [];

        if(this.props.order.product.exclude_optional_attributes){
            exclude_attribute_ids = JSON.parse(this.props.order.product.exclude_optional_attributes);
        }

        if(this.props.order.product != null && packaging_number != null && packaging_number > 1 && packaging_number < 6){

            if(this.props.order.product.product_number === "NKO2S-XP" || this.props.order.product.product_number === "NKOMM2S-XP" || this.props.order.product.product_number === "NKOMF2S-XP" || this.props.order.product.product_number === "NKOFM2S-XP" || this.props.order.product.product_number === "NKOFF2S-XP"){
                if(this.props.order.product.product_number === "NKO2S-XP"){

                    if(!exclude_attribute_ids.includes(4)){
                        general_attributes.push({ name: "[H]... Translucent Heat Shrink", input_name: "heatshrink", value: "H" });
                    }

                }else {

                    if(!exclude_attribute_ids.includes(1)){
                        general_attributes.push({ name: "[NC]... Noise Canceling Protection Cover (SCNO*X-A-NC)", input_name: "noisecancel", value: "NC"});
                    }

                    if(!exclude_attribute_ids.includes(4)){
                        general_attributes.push({ name: "[H]... Translucent Heat Shrink", input_name: "heatshrink", value: "H" });
                    }
                }
            }else {

                if(!exclude_attribute_ids.includes(1)){
                    general_attributes.push({ name: "[NC]... Noise Canceling Protection Cover (SCNO*X-A-NC)", input_name: "noisecancel", value: "NC"});
                }

                if(!exclude_attribute_ids.includes(2)){
                    general_attributes.push({ name: "[X]... Crossed Fiber Wiring A-A; B-B", input_name: "crossedfiber", value: "X" });
                }

                if(!exclude_attribute_ids.includes(3)){
                    general_attributes.push({ name: "[F]... Female Drum Assembly", input_name: "femaledrum", value: "F" });
                }

                if(!exclude_attribute_ids.includes(4)){
                    general_attributes.push({ name: "[H]... Translucent Heat Shrink", input_name: "heatshrink", value: "H" });
                }

                if(!exclude_attribute_ids.includes(5)){
                    general_attributes.push({ name: "[SP]... Inverted powerCON IN/OUT", input_name: "invertedpower", value: "SP" });
                }
            }

        }else {

            if(this.props.order.product != null && (this.props.order.product.product_number === "NKO2S-XP" || this.props.order.product.product_number === "NKOMM2S-XP" || this.props.order.product.product_number === "NKOMF2S-XP" || this.props.order.product.product_number === "NKOFM2S-XP" || this.props.order.product.product_number === "NKOFF2S-XP")){

                if(this.props.order.product.product_number === "NKO2S-XP"){
                    if(!exclude_attribute_ids.includes(4)){
                        general_attributes.push({ name: "[H]... Translucent Heat Shrink", input_name: "heatshrink", value: "H" });
                    }
                }else {
                    if(!exclude_attribute_ids.includes(1)){
                        general_attributes.push({ name: "[NC]... Noise Canceling Protection Cover (SCNO*X-A-NC)", input_name: "noisecancel", value: "NC"});
                    }

                    if(!exclude_attribute_ids.includes(4)){
                        general_attributes.push({ name: "[H]... Translucent Heat Shrink", input_name: "heatshrink", value: "H" });
                    }
                }
            }else {
                if(!exclude_attribute_ids.includes(1)){
                    general_attributes.push({ name: "[NC]... Noise Canceling Protection Cover (SCNO*X-A-NC)", input_name: "noisecancel", value: "NC"});
                }

                if(!exclude_attribute_ids.includes(2)){
                    general_attributes.push({ name: "[X]... Crossed Fiber Wiring A-A; B-B", input_name: "crossedfiber", value: "X" });
                }

                if(!exclude_attribute_ids.includes(4)){
                    general_attributes.push({ name: "[H]... Translucent Heat Shrink", input_name: "heatshrink", value: "H" });
                }
            }
        }

        return general_attributes;
    }

    getBreakoutConnectors() {

        let breakout_connectors = [];

        let exclude_attribute_ids = [];

        if(this.props.order.product.exclude_optional_attributes){
            exclude_attribute_ids = JSON.parse(this.props.order.product.exclude_optional_attributes);
        }

        if(this.props.order.product !== null && (this.props.order.product.product_details.connector_type.indexOf("Breakout") !== -1 || this.props.order.product.product_number === "NKOMM2S-XP" || this.props.order.product.product_number === "NKOMF2S-XP" || this.props.order.product.product_number === "NKOFM2S-XP" || this.props.order.product.product_number === "NKOFF2S-XP" || this.props.order.product.product_number.indexOf("NKOB") !== -1)){
            if(!exclude_attribute_ids.includes(7)){
                breakout_connectors.push({ name: "LCA", input_name: "breakout_connector", value: "LCA" });
            }

            if(!exclude_attribute_ids.includes(8)){
                breakout_connectors.push({ name: "ST", input_name: "breakout_connector", value: "ST" });
            }

            if(!exclude_attribute_ids.includes(9)){
                breakout_connectors.push({ name: "SC", input_name: "breakout_connector", value: "SC" });
            }
        }else {

            if(!exclude_attribute_ids.includes(6)){
                breakout_connectors.push({ name: "LC", input_name: "breakout_connector", value: "LC"});
            }

            if(!exclude_attribute_ids.includes(7)){
                breakout_connectors.push({ name: "LCA", input_name: "breakout_connector", value: "LCA" });
            }

            if(!exclude_attribute_ids.includes(8)){
                breakout_connectors.push({ name: "ST", input_name: "breakout_connector", value: "ST" });
            }

            if(!exclude_attribute_ids.includes(9)){
                breakout_connectors.push({ name: "SC", input_name: "breakout_connector", value: "SC" });
            }
        }


        return breakout_connectors;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.order.product != null){
            this.setState({general_attributes: this.getGeneralAttributes(nextProps.order.product.packaging_number), breakout_connectors: this.getBreakoutConnectors()});
        }
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this).scrollIntoView();
    }

    onOptionalAttributeChanged(name, state){

        var attributes = {};

        if(this.props.order.optional_attributes !== null){
            attributes = this.props.order.optional_attributes;
        }

        if(state != null){
            attributes[name] = state;
        }else {
            delete attributes[name];
        }

        this.props.setOptionalAttributes({
            optional_attributes: attributes
        });

        this.getProduct(attributes);
    }

    getProduct(optional_attributes){

        const _this = this;

        axios.post(_this.props.config.api_path+'api/getProduct', querystring.stringify({
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type,
            fiber_type: this.props.order.fiber_type,
            cable_type: this.props.order.cable_type,
            cable_length: this.props.order.cable_length,
            packaging_type: this.props.order.packaging_type,
            optional_attributes: JSON.stringify(optional_attributes),
            price_tier: this.props.user.price_tier
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setProduct({
                product: response.data.product
            })
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    onAddToCart(){

        var product = $.extend(true, {}, this.props.order.product);
        product.quantity = this.props.order.quantity;
        product.product_type = this.props.order.product_type;

        this.props.addProduct({
            product: product
        });

        $(".basket").removeClass("wobble");
        $(".basket").addClass("wobble");

        const _this = this;

        setTimeout(function () {
            _this.updateSessionCart();
        }, 1000);

    }

    updateSessionCart(){

        const _this = this;

        axios.post(_this.props.config.api_path+'updateSessionCart', querystring.stringify({
            cart: JSON.stringify(this.props.cart.items)
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

        })
        .catch(function (error) {
            console.log(error);
        });
    }

    render()
    {
        const { photoIndex, lightboxIsOpen } = this.state;

        const images = [
            this.props.config.optional_attributes_image
        ];

        return(
            <div className="content-container">

                {lightboxIsOpen && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => this.setState({ lightboxIsOpen: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + images.length - 1) % images.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + 1) % images.length,
                            })
                        }
                    />
                )}

                {this.props.order.product != null && this.props.order.product.product_number !== "NKOP2S-XP" ?

                    <div className="content">
                        <div className="configurator_form">
                            <div id="optional_attributes">
                                <div className="row">
                                    <h1>3. Optional Attributes</h1>
                                    <p>Select any optional attributes you desire.</p>
                                    <div className="advise">
                                        Please contact our Neutrik Sales for further advise with attributes!
                                    </div>
                                    <div className="annotation optionalAttributesInfo"
                                         onClick={() => this.setState({lightboxIsOpen: true})}>
                                        Click <span>here</span> to show optional attributes explanation
                                    </div>

                                    {this.props.order.product.product_number !== "NKOBM2S-XP" && this.props.order.product.product_number !== "NKOBF2S-XP" &&
                                    <div>
                                        <h2>3.1 General Attributes</h2>
                                        <StaticCheckboxFormType types={this.state.general_attributes}
                                            onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                            checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>

                                    }

                                </div>

                                { this.props.order.cable_type !== 25 && this.props.order.cable_type !== 26 && this.props.order.cable_type !== 27 && this.props.order.cable_type !== 56 && this.props.order.product.product_number !== "NKO2S-XP" &&
                                <div className="row">
                                    <h2>3.2 Breakout Connector [BO]</h2>
                                    <p>Choose the desired breakout connector (optional) for your product.</p>
                                    <p className="annotation"><b>Note:</b> FC, STA, SCA, FCA, E2000 available upon
                                        request.
                                    </p>
                                    <StaticRadioFormType types={this.state.breakout_connectors}
                                                         onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                         checkedAttributes={this.props.order.optional_attributes}/>
                                </div>
                                }
                                { this.props.order.cable_type !== 25 && this.props.order.cable_type !== 26 && this.props.order.cable_type !== 27 && this.props.order.cable_type !== 56 && this.props.order.product.product_number !== "NKOBM2S-XP" && this.props.order.product.product_number !== "NKOBF2S-XP" &&
                                <div className="row">
                                    <h2>3.3 Cable Labelling [T]</h2>
                                    <p>Choose the desired labelling (optional) for your product.</p>
                                    <div className="col-dt-50 col-tbl-full">
                                        <StaticInputFormType name="Line 1" input_name="cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                    </div>
                                </div>
                                }
                                { ((this.props.order.product_type === "single" || this.props.order.product_type === "dragonfly") && this.props.order.product.product_number !== "NKOBM2S-XP" && this.props.order.product.product_number !== "NKOBF2S-XP") &&
                                <div className="row">
                                    <h2>3.4 Connector Color Coding [C]</h2>
                                    <p>Choose the desired color coding (optional) for your connector</p>
                                    <StaticRadioFormType types={this.state.connector_color_codings}
                                                         onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                         checkedAttributes={this.props.order.optional_attributes}/>
                                </div>
                                }
                                { (this.props.order.product_type === "split" || this.props.order.product_type === "powersplit" || this.props.order.product_type === "powersplit25") &&
                                <div className="row">
                                    <h2>3.4 Split Length [SL]</h2>
                                    <div className="col-dt-50 col-tbl-full">
                                        <StaticInputFormType name="Split Length" input_name="split_length"
                                                             placeholder="(in metres)"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             maxLength="2"
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <p className="annotation"><b>Note:</b> The maximum split length is 2m (6.56ft).
                                        </p>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">

                                    </div>
                                </div>
                                }
                                { (this.props.order.product_type === "split" || this.props.order.product_type === "powersplit" || this.props.order.product_type === "powersplit25") &&
                                <div className="row">
                                    <h2>3.5 Split Text [STC]</h2>
                                    <p>Choose the desired split text (optional) for your product.</p>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC0</h3>
                                        <p>Split Text Black</p>
                                        <StaticInputFormType name="Line 1" input_name="stc0_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc0_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC1</h3>
                                        <p>Split Text Brown</p>
                                        <StaticInputFormType name="Line 1" input_name="stc1_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc1_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC2</h3>
                                        <p>Split Text Red</p>
                                        <StaticInputFormType name="Line 1" input_name="stc2_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc2_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC3</h3>
                                        <p>Split Text Orange</p>
                                        <StaticInputFormType name="Line 1" input_name="stc3_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc3_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC4</h3>
                                        <p>Split Text Yellow</p>
                                        <StaticInputFormType name="Line 1" input_name="stc4_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc4_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC5</h3>
                                        <p>Split Text Green</p>
                                        <StaticInputFormType name="Line 1" input_name="stc5_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc5_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC6</h3>
                                        <p>Split Text Blue</p>
                                        <StaticInputFormType name="Line 1" input_name="stc6_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc6_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC7</h3>
                                        <p>Split Text Violet</p>
                                        <StaticInputFormType name="Line 1" input_name="stc7_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc7_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC8</h3>
                                        <p>Split Text Grey</p>
                                        <StaticInputFormType name="Line 1" input_name="stc8_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc8_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                    <div className="col-dt-50 col-tbl-full">
                                        <h3>STC9</h3>
                                        <p>Split Text White</p>
                                        <StaticInputFormType name="Line 1" input_name="stc9_cable_label_1"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                        <StaticInputFormType name="Line 2" input_name="stc9_cable_label_2"
                                                             placeholder="Cable Labelling"
                                                             onOptionalAttributeChanged={(name, state) => this.onOptionalAttributeChanged(name, state)}
                                                             checkedAttributes={this.props.order.optional_attributes}/>
                                    </div>
                                </div>
                                }
                            </div>
                            {this.props.order.product !== null && this.props.user.user !== null &&
                            <div>
                                <div className="hr"></div>
                                <div className="align-right">
                                    <button type="button" onClick={() => this.onAddToCart()}>Add product to cart »
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    :
                    <div className="content">
                        <div className="configurator_form">
                            <div id="optional_attributes">
                                <div className="row">
                                    <h1>3. Optional Attributes</h1>
                                    <p>No optional attributes available for this product.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    order: state.order,
    user: state.user,
    cart: state.cart
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setOptionalAttributes,
    setProduct,
    addProduct
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OptionalAttributes)



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/OptionalAttributes/index.js